import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row, Col} from 'reactstrap';
import "react-datepicker/dist/react-datepicker.css";
import Parenticn from 'assets/img/parents-icn.png';
import Childicn from 'assets/img/children-icn.png';
import Mentorcn from 'assets/img/mentor-icon.png';
import Adminicn from 'assets/img/admin-icn.png';
import Page from 'components/Page';
import AppConstants from 'AppConstants';
import { NumberWidget, IconWidget } from 'components/Widget';
import {ReactTitle} from 'react-meta-tags';
import Loader from 'react-loader';

class DashboardPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      child_count : 0,
      admin_count : 0,
      parent_count : 0,
      mentor_count : 0,
      page_loader : false,
    };
  }
  componentDidMount() {
    fetch(AppConstants.API+'/users/getAllAdminCount').then(response => response.json())
    .then(res => {   
     if(res.message == "success"){      
      //  console.log("res",res);
      if(res.admin.length > 0){
        this.setState({
          admin_count : res.admin.length,
          page_loader : true,
        });
      }else{
        this.setState({
          page_loader : true,
        });
      }
      
      setTimeout(() => {
        this.setState({
          errMsg: false,
        });
      }, 1000);
              
    }
    else{
      this.setState({
        errMsg: res.msg
      });
    }
  });
  fetch(AppConstants.API+'/child/getAllChildren').then(response => response.json())
  .then(res => { 
    if(res.data.length != 0){
      this.setState({child_count:res.data.length});
    }
  })
  fetch(AppConstants.API+'/parent/getAllParents').then(response => response.json())
  .then(res => { 
    if(res.data.length != 0){
     this.setState({parent_count:res.data.length})
    }
  })
  fetch(AppConstants.API+'/mentor/getAllMentors').then(response => response.json())
  .then(res => { 
    if(res.data.length != 0){
      this.setState({mentor_count:res.data.length})
    }
  })
  var element = document.getElementById("navItem-Students-0");
  element.classList.remove("active");
  var element = document.getElementById("navItem-Parents-1");
  element.classList.remove("active");
  var element = document.getElementById("navItem-Mentors-2");
  element.classList.remove("active");
  var element = document.getElementById("navItem-Cms-0");
  element.classList.remove("active");
  var element = document.getElementById("navItem-Programs-3");
  element.classList.remove("active");
  var element = document.getElementById("navItem-Events-1");
  element.classList.remove("active");
  if(!this.props.auth.user.user_type){
    element = document.getElementById("navItem-Admins-0");
    element.classList.remove("active");
  }
  var element = document.getElementById("navItem-dashboard-0");
  element.classList.add("active");
  var element = document.getElementById("navItem-Resources-0");
  element.classList.remove("active");
  var element = document.getElementById("navItem-Languages-1");
  element.classList.remove("active");
  var element = document.getElementById("navItem-Thermometer Questions-0");
  element.classList.remove("active");
  var element = document.getElementById("navItem-Feeling Journals-0");
  element.classList.remove("active");
  var element = document.getElementById("navItem-Parent TO-DOS-1");
  element.classList.remove("active");
  var element = document.getElementById("navItem-Student TO-DOS-0");
  element.classList.remove("active");
  var element = document.getElementById("navItem-Mentor TO-DOS-2");
  element.classList.remove("active");
  var element = document.getElementById("navItem-Help Sugesstions-0");
  element.classList.remove("active");
  var element = document.getElementById("navItem-Help-1");
  element.classList.remove("active");
  var element = document.getElementById("navItem-App Feedback-0");
  element.classList.remove("active");
  var element = document.getElementById("navItem-Event Feedback-1");
  element.classList.remove("active");
  }
  render() {
    return ( 
      <Loader loaded={this.state.page_loader}  >
      <Page
        className="DashboardPage"
        title="Dashboard"
        /*breadcrumbs={[{ name: 'Dashboard', active: true }]}*/>
        <ul className="cst-breadcrumb">
          {/* <li>Home</li>
          <li>Dashboard</li> */}
        </ul>
        <ReactTitle title="Dashboard"/>
        <Row>
        {!this.props.auth.user.user_type ?
           <Col lg={3} md={6} sm={6} xs={12} className="cst-db-block mb-2 b1">
            <Link to={"/allusers"} style={{ textDecoration: 'none' }} title="All Admins">
            <img src={Adminicn} width="60" height="" className="pr-2" alt="" />
              <NumberWidget
                title="Admins"
                number={this.state.admin_count} 
                color="secondary"
              />
            </Link>
          </Col>:""}
          
          <Col lg={3} md={6} sm={6} xs={12} className="cst-db-block mb-2 b2">
            <Link to={"/allChildren"} style={{ textDecoration: 'none' }} title="All Students">
            <img src={Childicn} width="60" height="" className="pr-2" alt="" />
              <NumberWidget
                title="Students"
                number={this.state.child_count} 
                color="secondary"
              />
            </Link>
          </Col>
          <Col lg={3} md={6} sm={6} xs={12} className="cst-db-block mb-2 b3">
            <Link to={"/Allparents"} style={{ textDecoration: 'none' }} title="All Parents">
            <img src={Parenticn} width="60" height="" className="pr-2" alt="" />
              <NumberWidget
                title="Parents"
                number={this.state.parent_count} 
                color="secondary"
              />
            </Link>
          </Col>
          <Col lg={3} md={6} sm={6} xs={12} className="cst-db-block mb-2 b4">
            <Link to={"/allmentors"} style={{ textDecoration: 'none' }} title="All Participants">
            <img src={Mentorcn} width="60" height="" className="pr-2" alt="" />
              <NumberWidget
                title="Participants"
                number={this.state.mentor_count} 
                color="secondary"
              />
            </Link>
          </Col>
        </Row>
      </Page>
      </Loader>    
    );
  }
}
const mapStateToProps = (state) => ({
  auth: state.auth
});
export  default connect(mapStateToProps, {})(DashboardPage);
//export default DashboardPage;